import React from 'react'
import moment from 'moment'

// components
import {
  CRow,
} from '@coreui/react-pro'
import FormSelectInput from '../general-input-form/FormSelectInput'
import FormDatePicker from '../general-input-form/FormDatePicker'

const AppFormExportLetterNumber = ({
  errors,
  exportModeOptions,
  exportMode,
  handleSelectExportMode,
  letterTypeOptions,
  letterType,
  handleSelectLetterType,
  monthOptions,
  month,
  handleSelectMonth,
  values,
  onDateChange
}) => {
  return (
    <>
      <CRow className="mb-4">
        <FormSelectInput
          id='export_mode'
          name='export_mode'
          colSize='6'
          inputLabel='Export Period'
          className='mb-3'
          selectOptions={exportModeOptions}
          value={exportMode}
          handleSelectInput={handleSelectExportMode}
          feedbackInvalid={errors.mode}
          invalid={errors.mode}
          disabled={false}
          multiple={false}
          placeholder='Please select export period...'
        />
        <FormSelectInput
          id='letter_types'
          name='letter_types'
          colSize='6'
          inputLabel='Letter Type'
          className='mb-3'
          selectOptions={letterTypeOptions}
          value={letterType}
          handleSelectInput={handleSelectLetterType}
          feedbackInvalid={errors.letter_types}
          invalid={errors.letter_types}
          disabled={false}
          multiple={true}
          placeholder='All types'
        />
        {
          values?.mode === 'date' && (
            <>
              <FormDatePicker
                id='start_date'
                name='start_date'
                colSize='6'
                inputLabel='Start Date'
                className='mb-3'
                handleOnDateChange={onDateChange}
                value={values?.start_date}
                feedbackInvalid={errors.start_date}
                invalid={errors.start_date}
              />
              <FormDatePicker
                id='end_date'
                name='end_date'
                colSize='6'
                inputLabel='End Date'
                className='mb-3'
                handleOnDateChange={onDateChange}
                value={values?.end_date}
                feedbackInvalid={errors.end_date}
                invalid={errors.end_date}
                minDate={values?.start_date ? moment(values.start_date).toDate() : undefined}
              />
            </>
          )
        }
        {
          values?.mode === 'monthly' && (
            <FormSelectInput
              id='month'
              name='month'
              colSize='6'
              inputLabel='Select Month'
              className='mb-3'
              selectOptions={monthOptions}
              value={month}
              handleSelectInput={handleSelectMonth}
              feedbackInvalid={errors.months}
              invalid={errors.months}
              disabled={false}
              multiple={true}
              placeholder='Please select month...'
            />
          )
        }
      </CRow>
    </>
  )
}

export default AppFormExportLetterNumber
